import { DrivingSchoolDATEV } from "./drivingSchool/datev/DrivingSchoolDATEV";
import { DrivingSchoolServiceEntries } from "./drivingSchool/DrivingSchoolServiceEntries";
import { useGetRecordId } from "react-admin";
import { Navigate, Route, Routes } from "react-router-dom";
import { ShowBase } from "../misc/ShowBase";
import { DrivingSchoolFleet } from "./drivingSchool/DrivingSchoolFleet";
import { DrivingSchoolPracticalExamWorkflowsBoard } from "./drivingSchool/DrivingSchoolPracticalExamWorkflowsBoard";
import { DrivingSchoolStudents } from "./drivingSchool/DrivingSchoolStudents";
import { DrivingSchoolTheoryExamWorkflowsBoard } from "./drivingSchool/DrivingSchoolTheoryExamWorkflowsBoard";
import { DrivingSchoolExaminationAssignments } from "./drivingSchool/DrivingSchoolExaminationAssignments";
import { DrivingSchoolPerformanceOverview } from "./drivingSchool/DrivingSchoolPerformanceOverview";
import { PayoutOverview } from "./drivingSchool/DrivingSchoolPayouts.js";
import { TaxConsultantExports } from "./drivingSchool/DrivingSchoolTaxConsultantsDownloads.js";
import { BusinessIntelligencePage } from "../misc/BusinessIntelligencePage";
import { DrivingSchoolDashboard } from "./drivingSchool/DrivingSchoolDashboard";
import { DrivingSchoolAdminForm } from "./drivingSchool/DrivingSchoolAdminForm";
import { DrivingSchoolCourses } from "./drivingSchool/DrivingSchoolCourses";
import { DrivingSchoolBranches } from "./drivingSchool/DrivingSchoolBranches";
import { DrivingSchoolExamLocations } from "./drivingSchool/DrivingSchoolExamLocations";
import { DrivingSchoolDunning } from "./drivingSchool/DrivingSchoolDunning";
import { DrivingSchoolLabels } from "./drivingSchool/DrivingSchoolLabels";
import { restrictAccessToDrivingSchoolIds } from "../backoffice.access_control";
import { useLocation, useNavigate } from "react-router";
import { DrivingSchoolExams } from "./drivingSchool/DrivingSchoolExams";
import { DrivingSchoolManualRefunds } from "./drivingSchool/DrivingSchoolManualRefunds";
import { DrivingSchoolManualPayments } from "./drivingSchool/DrivingSchoolManualPayments";
import { DrivingSchoolTimetables } from "./drivingSchool/DrivingSchoolTimetables";
import { DrivingSchoolCourseTemplates } from "./drivingSchool/DrivingSchoolCourseTemplates";
import { DrivingSchoolAutoForms } from "./drivingSchool/DrivingSchoolAutoForms";
import { DrivingSchoolRooms } from "./drivingSchool/DrivingSchoolRooms";
import { DrivingSchoolEmployees } from "./drivingSchool/DrivingSchoolEmployees";
import { DrivingSchoolOtherEventCategories } from "./drivingSchool/DrivingSchoolOtherEventCategories";
import { DrivingSchoolServiceTypes } from "./drivingSchool/DrivingSchoolServiceTypes";
import { DrivingSchoolSubscriptionPackages } from "./drivingSchool/DrivingSchoolSubscriptionPackages";
import { DrivingSchoolCustomCards } from "./drivingSchool/DrivingSchoolCustomCards";
import { DrivingSchoolInvoiceCustomers } from "./drivingSchool/DrivingSchoolInvoiceCustomers";
import { DrivingSchoolScheduler } from "./drivingSchool/DrivingSchoolScheduler";
import { DrivingSchoolPlatformPayments } from "./drivingSchool/DrivingSchoolPlatformPayments";
import { DrivingSchoolBKFOverview } from "./drivingSchool/DrivingSchoolBKFOverview";

export function DrivingSchoolRoutes() {
  const drivingSchoolId = useGetRecordId().toString();
  const navigate = useNavigate();
  const { search } = useLocation();

  if (
    drivingSchoolId &&
    restrictAccessToDrivingSchoolIds &&
    !restrictAccessToDrivingSchoolIds.includes(drivingSchoolId)
  ) {
    setTimeout(() => navigate("/"));
    return null;
  }

  return (
    <ShowBase key={drivingSchoolId /* ... to prevent that old data is shown when the driving school is switched. */}>
      <Routes>
        <Route path="/" element={<DrivingSchoolDashboard />} />
        <Route path="datev" element={<DrivingSchoolDATEV />} />
        <Route path="calendar" element={<Navigate to={`/drivingSchools/${drivingSchoolId}/courses${search}`} />} />
        <Route
          path="courses-calendar"
          element={<Navigate to={`/drivingSchools/${drivingSchoolId}/courses${search}`} />}
        />
        <Route
          path="courses-list"
          element={<Navigate to={`/drivingSchools/${drivingSchoolId}/courses${search}#list`} />}
        />
        <Route path="courses" element={<DrivingSchoolCourses />} />
        <Route path="scheduler" element={<DrivingSchoolScheduler />} />
        <Route path="employees" element={<DrivingSchoolEmployees />} />
        <Route
          path="instructors"
          element={<Navigate to={`/drivingSchools/${drivingSchoolId}/employees#instructors`} />}
        />
        <Route
          path="customerService"
          element={<Navigate to={`/drivingSchools/${drivingSchoolId}/employees#office`} />}
        />
        <Route path="support" element={<Navigate to={`/drivingSchools/${drivingSchoolId}/employees#office`} />} />
        <Route path="students" element={<DrivingSchoolStudents />} />
        <Route
          path="studentsWithoutInstructors"
          element={<Navigate to={`/drivingSchools/${drivingSchoolId}/students#studentsWithoutInstructors`} />}
        />
        <Route path="exams-calendar" element={<DrivingSchoolExams />} />
        <Route path="examinationAssignments" element={<DrivingSchoolExaminationAssignments title="Prüfaufträge" />} />
        <Route
          path="expiringSoonExaminationAssignments"
          element={
            <DrivingSchoolExaminationAssignments title="Prüfaufträge vor Ablauf" expirationState="expiringSoon" />
          }
        />
        <Route
          path="expiredExaminationAssignments"
          element={<DrivingSchoolExaminationAssignments title="Prüfaufträge abgelaufen" expirationState="expired" />}
        />
        <Route path="theoryExams" element={<DrivingSchoolTheoryExamWorkflowsBoard />} />
        <Route path="practicalExams" element={<DrivingSchoolPracticalExamWorkflowsBoard />} />
        <Route
          path="performanceOverview"
          element={<DrivingSchoolPerformanceOverview title="Leistungsübersicht" resource="performanceOverview" />}
        />
        <Route
          path="advancePayments"
          element={<DrivingSchoolPerformanceOverview title="Vorauszahlungen" resource="advancePayments" />}
        />
        <Route
          path="openInvoices"
          element={<DrivingSchoolPerformanceOverview title="Offene Posten" resource="openInvoices" />}
        />
        <Route path="payouts" element={<PayoutOverview />} />
        <Route path="tax" element={<TaxConsultantExports />} />
        <Route path="dunning/*" element={<DrivingSchoolDunning />} />
        <Route path="manualRefunds" element={<DrivingSchoolManualRefunds />} />
        <Route path="manualPayments" element={<DrivingSchoolManualPayments />} />
        <Route path="invoiceCustomers" element={<DrivingSchoolInvoiceCustomers />} />
        <Route path="platformPayments" element={<DrivingSchoolPlatformPayments />} />
        <Route path="bi" element={<BusinessIntelligencePage />} />
        <Route path="bkf" element={<DrivingSchoolBKFOverview />} />
        <Route path="branches" element={<DrivingSchoolBranches />} />
        <Route path="fleet" element={<DrivingSchoolFleet />} />
        <Route path="examLocations" element={<DrivingSchoolExamLocations />} />
        <Route path="labels" element={<DrivingSchoolLabels />} />
        <Route path="otherEventCategories" element={<DrivingSchoolOtherEventCategories />} />
        <Route path="timetables" element={<DrivingSchoolTimetables />} />
        <Route path="courseTemplates" element={<DrivingSchoolCourseTemplates />} />
        <Route path="autoForms" element={<DrivingSchoolAutoForms />} />
        <Route path="rooms" element={<DrivingSchoolRooms />} />
        <Route path="serviceEntries" element={<DrivingSchoolServiceEntries />} />
        <Route path="serviceTypes" element={<DrivingSchoolServiceTypes />} />
        <Route path="customCards" element={<DrivingSchoolCustomCards />} />
        <Route path="subscriptionPackages" element={<DrivingSchoolSubscriptionPackages />} />
        <Route path="admin" element={<DrivingSchoolAdminForm />} />
      </Routes>
    </ShowBase>
  );
}
